import { render } from "./ExcelReferencesRow.vue?vue&type=template&id=3fd2be38&scoped=true"
import script from "./ExcelReferencesRow.vue?vue&type=script&lang=js"
export * from "./ExcelReferencesRow.vue?vue&type=script&lang=js"

import "./ExcelReferencesRow.vue?vue&type=style&index=0&id=3fd2be38&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd2be38"]])

export default __exports__